// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AscendingSort: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5">
            <path
                fill="#393939"
                d="M4.28151037,1.47031236 C3.98854162,1.17734361 3.51276029,1.17734361 3.21979154,1.47031236 L0.219791545,4.47031236 C0.00416661633,4.68593693 -0.0591145621,5.00703096 0.0580729379,5.28828096 C0.175260438,5.56953096 0.447135581,5.75234354 0.751823081,5.75234354 L6.75182308,5.75234354 C7.05416669,5.75234354 7.32838572,5.56953096 7.44557322,5.28828096 C7.56276072,5.00703096 7.49713601,4.68593693 7.28385462,4.47031236 L4.28385462,1.47031236 L4.28151037,1.47031236 Z"
                transform="translate(-.002 -1)"
            />
        </svg>
    );
};

export default React.memo(AscendingSort);
